import { gql } from '@apollo/client';

export const GET_CARE_TEAMS_FOR_AUTOCOMPLETE = gql`
  query GetCareTeamsForAutocomplete($page: Int!, $perPage: Int!, $filter: FilterFindManyCareTeam) {
    orgUnit {
      careTeamPagination(page: $page, perPage: $perPage, filter: $filter) {
        items {
          id
          subOrganizations {
            id
            name
          }
          name
        }
        pageInfo {
          totalItems
          page
          perPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
